import classNames from 'classnames';
import React from 'react';
import { useDisableAppData, useLockAppData } from '@/hooks/use-disable-app';
import { useEditorModel } from '@/store/models/editor-model';
import { useTemplateModel } from '@/store/models/template-model';
import SaveBtn from './components/save-btn';
import RedoUndo from './redo-undo';
import './index.less';
import { Button, Modal } from '@meitu/saas-ui';
import { Switch } from '@meitu/xdesign-widgets';
import { isEditAIPPTComponent, isEditAIPPTTemplate } from '@/hooks/fetch-template/editor-mode';
import { editor } from '@/instance';
import { isInternalDesignerMode } from '@/utils/auth';
import { getQueryParam } from '@/utils/query';
import ClearMarkBtn from './components/clear-mark-btn/clear-mark-btn';
import Logo from './components/logo';
import PickUpMaterialBtn from './components/pick-up-material-btn/pick-up-material-btn';
import PptThemeBtn from './components/ppt-theme-btn/ppt-theme-btn';
import PreviewBtn from './components/preview';
import TemplateMarkBtn from './components/template-mark-btn/template-mark-btn';
import TemplateName from './components/template-name';
import UploadPsd from './components/upload-psd/upload-psd';

const { confirm } = Modal;

const Header = () => {
    const isLock = useLockAppData();
    const disableApp = useDisableAppData();
    const useWater = useTemplateModel((state) => state.useWatermark);
    const setUseWater = useTemplateModel((state) => state.setUseWatermark);
    const isShowTypo = useEditorModel((state) => state.isShowTypo);
    const setIsShowTypo = useEditorModel((state) => state.setIsShowTypo);

    const handelUseWater = () => {
        confirm({
            content: `确认${useWater ? '取消' : '使用'}该图暗水印？`,
            hideIcon: false,
            onOk() {
                setUseWater(!useWater);
            },
        });
    };

    return (
        <div className="p-header">
            <div className="p-header__left">
                <div className={classNames('can-disable', isLock, disableApp)}>
                    <Logo />
                    <div className="p-header__separater"></div>
                    <div className="p-header__template-name">
                        <TemplateName />
                    </div>
                    <RedoUndo />
                </div>
            </div>

            <div className="p-header__right">
                <span style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                    英文拼写检测：
                    <Switch checked={isShowTypo} onChange={setIsShowTypo} />
                </span>
                <UploadPsd />
                {isInternalDesignerMode() ? (
                    <div style={{ marginRight: '10px' }}>
                        <Button onClick={handelUseWater} type="default">
                            {useWater ? '取消暗水印' : '使用暗水印'}
                        </Button>
                    </div>
                ) : null}

                {isEditAIPPTTemplate() ? <PptThemeBtn editor={editor} /> : null}

                {isEditAIPPTComponent() || isEditAIPPTTemplate() ? <TemplateMarkBtn editor={editor} /> : null}

                {isEditAIPPTComponent() || isEditAIPPTTemplate() ? <ClearMarkBtn editor={editor} /> : null}

                {isEditAIPPTComponent() ? (
                    <Button
                        style={{ marginRight: '10px', width: '120px' }}
                        type="primary"
                        onClick={() => {
                            window.open(`?mode=internal_designer&smartComponentId=${getQueryParam('id')}&isPPTDemo=1`);
                        }}
                    >
                        智能组件Demo
                    </Button>
                ) : null}

                {isEditAIPPTComponent() ? (
                    <Button
                        style={{ marginRight: '10px', width: '120px' }}
                        type="primary"
                        onClick={() => {
                            window.open(`?mode=internal_designer&componentId=${getQueryParam('id')}&isPPTDemo=1`);
                        }}
                    >
                        普通组件Demo
                    </Button>
                ) : null}

                {isInternalDesignerMode() ? <PreviewBtn /> : null}

                <PickUpMaterialBtn />
                <SaveBtn />
            </div>
        </div>
    );
};

export default React.memo(Header);
